module.exports = __webpack_public_path__ + "images/emoji/shell.1e42b1b7875a6972b6b9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/shell.png
// module id = mYEs
// module chunks = 14